
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
@Component({
  name: "BreedHeader",
  components: {},
})
export default class BreedHeader extends Vue {
  @Prop({ type: String }) title!: any;
  @Prop({ type: String }) preSearch?: any;
  @Prop({ type: Number }) total!: any;
  @Prop({ type: Number }) time!: any;
  @Prop({ type: Number }) current!: any;
  @Prop({ type: Array }) btns!: any;
  searchValue: any = "";
  active: number = 0;
  sortList = [
    {
      value: null,
      label: "最新",
    },
    {
      value: "时间",
      label: "时间",
    },
    {
      value: "热度",
      label: "热度",
    },
  ];
  mounted() {
    if (this.preSearch) {
      this.searchValue = this.preSearch;
    }
  }
  search() {
    this.$emit("search", { likeParam: this.searchValue });
  }
  currentChange(index: any) {
    this.$emit("currentChange", index);
  }
}
